<template>
    <div v-if="show">
        <div class="card" v-show="operation !== 'detail'">
            <div class="card-header card-header-flex pb-2">
                <div class="w-100 mt-2">
                    <div class="row">
                        <div class="col-8">
                            <h5 class="mt-3 ml-0 mr-3 mb-2">
                                <strong>
                                    <template v-if="operation === null">
                                        {{$t('title.invoices')}}
                                        <span v-if="pagination.total">({{pagination.total}})</span>
                                    </template>
                                    <template v-else>{{ $t(operationTitle) }}</template>
                                </strong>
                            </h5>
                        </div>
                        <div class="col-4 text-right">
                            <div v-if="operation === null">
                                <div class="mt-3">
                                    <!-- Using components -->
                                    <b-input-group class="mt-3">
                                        <b-form-input type="search" class="form-control form-control-sm"
                                                      :placeholder="$t('input.whatAreYouLookingFor')"
                                                      v-on:keyup.enter="handleSearch" v-model="search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" :title="$t('button.title.filterRecords')"
                                                      variant="outline-info"
                                                      @click="filters.visible = !filters.visible" v-b-tooltip.hover
                                                      v-if="$global.hasPermission('preinvoicesview')">
                                                <i class="fa fa-filter"></i>
                                            </b-button>
                                            <b-button size="sm" :title="$t('button.title.exportExcel')"
                                                      variant="outline-info"
                                                      @click="handleExcelExportClick" v-b-tooltip.hover
                                                      v-if="$global.hasPermission('preinvoicesview')">
                                                <i class="fa fa-file-excel-o"></i>
                                            </b-button>
                                            <b-button size="sm" :title="$t('button.title.resetList')"
                                                      variant="outline-info"
                                                      @click="handleResetFilterClick()" v-b-tooltip.hover>
                                                <i class="fa fa-refresh"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </div>
                            </div>
                            <div v-else>
                                <b-button variant="warning" size="sm" class="mt-3"
                                          @click="handleOperationClose()"
                                          v-b-tooltip.hover :title="$t('button.title.cancel')">
                                    <i class="fa fa-arrow-left"></i> {{$t('button.cancel')}}
                                </b-button>
                            </div>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.w-100 -->
            </div><!-- /.card-header -->
            <div class="card-body">
                <div class="preinvoice-table">
                    <b-table hover responsive
                             :busy="listingLoading"
                             :items="dataSource"
                             :fields="columns"
                             :sort-by.sync="sortField"
                             ref="orderTable"
                             @sort-changed="handleSortChange">
                        <template v-slot:cell(supplier)="record">
                            {{ (record.item.supplier || {}).name }}
                        </template>
                        <template v-slot:cell(invoice_date)="record">
                            {{ $global.utcDateToLocalDate(record.item.invoice_date, 'DD.MM.YYYY', 'YYYY-MM-DD')}}
                        </template>
                        <template v-slot:cell(created_at)="record">
                            {{ $global.utcDateToLocalDate(record.item.created_at)}}
                        </template>
                        <template v-slot:cell(price)="record">
                            {{ record.item.price }} EUR
                        </template>
                        <template v-slot:cell(status)="record">
                            <span class="badge badge-danger">
                                Open
                            </span>
                        </template>
                        <template v-slot:cell(action)="record">
                            <a @click="setOperation('edit', record.item.id)"
                               :title="$t('button.title.editItem')"
                               v-if="$global.hasPermission('preinvoicesupdate') && record.item.status == 1"
                               v-b-tooltip.hover>
                                <i class="fe fe-edit"></i>
                            </a>
                            <a-popconfirm title="Are you sure？" @confirm="handleDeleteClick(record.item.id)"
                                          v-if="$global.hasPermission('preinvoicesdestroy')">
                                <i slot="icon" class="fe fe-trash"></i>
                                <a class=" ml-1"
                                   :title="$t('button.title.deleteItem')"
                                   v-b-tooltip.hover>
                                    <i class="fe fe-trash"></i>
                                </a>
                            </a-popconfirm>
                            <a @click="setOperation('detail', record.item.id)"
                               :title="$t('button.title.detailItem')" class=" ml-1"
                               v-if="$global.hasPermission('preinvoicesview')"
                               v-b-tooltip.hover>
                                <i class="icmn-info"></i>
                            </a>
                        </template>
                    </b-table><!-- /.b-table -->
                    <div class="clearfix">
                        <div class="float-left">
                            <b-form-select v-model="pagination.perPage" :options="[5, 10, 50, 100, 1000]"
                                           size="sm"></b-form-select>
                        </div>
                        <div class="float-right">
                            <b-pagination
                                v-model="pagination.current"
                                :total-rows="pagination.total"
                                :per-page="pagination.perPage"
                                :first-text="$t('paginations.first')"
                                :prev-text="$t('paginations.prev')"
                                :next-text="$t('paginations.next')"
                                :last-text="$t('paginations.last')"
                            ></b-pagination>
                        </div><!-- /.pull-right -->
                    </div><!-- /.clearfix -->
                </div><!-- /.preinvoice-table-->
                <div class="preinvoice-operation">
                    <a-drawer
                        placement="right"
                        :width="'950px'"
                        :wrapStyle="{overflow: 'auto',paddingBottom: '108px'}"
                        :closable="false"
                        @close="handleOperationClose"
                        :visible="operation !== null && operation !== 'detail'"
                        :zIndex="10"
                        :title="$t(operationTitle)"
                    >
                        <form @submit.prevent="handleSubmit" autocomplete="off">
                            <b-row>
                                <b-col cols="12" v-show="global.pendingRequests > 0">
                                    <a-skeleton active :paragraph="{ rows: 10 }"/>
                                </b-col>
                                <b-col cols="12" v-show="global.pendingRequests <= 0">
                                    <b-row v-if="editInvoice">
                                        <b-col cols="12">
                                            <b-row>
                                                <b-col md="6" lg="6" sm="12">{{$t('title.supplier')}}</b-col><!--/.col-->
                                                <b-col md="6" lg="6" sm="12"><div class="text-right">{{(formFields.supplier || {}).name}}</div></b-col><!--/.col-->
                                            </b-row>
                                            <b-row>
                                                <b-col md="6" lg="6" sm="12">{{$t('title.invoiceDate')}}</b-col><!--/.col-->
                                                <b-col md="6" lg="6" sm="12"><div class="text-right">{{$global.dateFormat(editInvoice.invoice_date)}}</div></b-col><!--/.col-->
                                            </b-row>
                                            <b-row>
                                                <b-col md="6" lg="6" sm="12">{{$t('title.totalCost')}}</b-col><!--/.col-->
                                                <b-col md="6" lg="6" sm="12"><div class="text-right">{{ formFields.price }} EUR</div></b-col><!--/.col-->
                                            </b-row>
                                            <b-row>
                                                <b-col md="6" lg="6" sm="12">{{$t('title.numberOfLoads')}}</b-col><!--/.col-->
                                                <b-col md="6" lg="6" sm="12"><div class="text-right">{{ editInvoiceItems.length }}</div></b-col><!--/.col-->
                                            </b-row>
                                            <b-row>
                                                <b-col sm="12"><h4 class="mt-2">Loads</h4><hr /></b-col>
                                                <b-col sm="12">
                                                    <p class="text-danger" v-if="editInvoiceItems.length === formFields.deleted_items.length && formFields.deleted_items.length > 0">{{$t('msc.allItemsDeletedInValidForm')}}</p>
                                                    <b-row>
                                                        <b-col sm="12" v-for="(item, index) in editInvoiceItems" :key="index">
                                                            <a class="badge badge-danger" v-if="!_.includes(formFields.deleted_items, item.object_guid)" @click="() => handleInvoiceItemClick(item)">{{$t('button.delete')}}</a>
                                                            <a class="badge badge-info" v-if="_.includes(formFields.deleted_items, item.object_guid)" @click="() => handleUndoDeleteInvoiceItemClick(item)">
                                                                {{$t('button.undo')}} {{$t('button.delete')}}
                                                            </a>
                                                            <b-row>
                                                                <b-col md="6" lg="6" sm="12">{{$t('title.loadNumber')}}</b-col><!--/.col-->
                                                                <b-col md="6" lg="6" sm="12"><div class="text-right">{{ item.item.load_number }}</div></b-col><!--/.col-->
                                                            </b-row>
                                                            <b-row>
                                                                <b-col md="6" lg="6" sm="12">{{$t('title.route')}}</b-col><!--/.col-->
                                                                <b-col md="6" lg="6" sm="12"><div class="text-right">{{ (item.item.route || {}).name }}</div></b-col><!--/.col-->
                                                            </b-row>
                                                            <b-row>
                                                                <b-col md="6" lg="6" sm="12">{{$t('title.costPerLoad')}}</b-col><!--/.col-->
                                                                <b-col md="6" lg="6" sm="12">
                                                                    <div class="text-right">
                                                                        {{ item.price }}
                                                                        <span>{{ (item.currency || {}).label }}</span>
                                                                    </div>
                                                                </b-col><!--/.col-->
                                                            </b-row>
                                                            <b-row>
                                                                <b-col sm="12">
                                                                    <table class="table table-sm">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>#</th>
                                                                                <th>{{$t('title.vinNumber')}}</th>
                                                                                <th>{{$t('title.orderId')}}</th>
                                                                                <th>{{$t('title.brand')}}</th>
                                                                                <th>{{$t('title.model')}}</th>
                                                                                <th>{{$t('title.price')}}</th>
                                                                                <th>{{$t('title.currency')}}</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="(inboundLoadItem, iIndex) in item.item.sub_items">
                                                                                <td>{{iIndex + 1}}</td>
                                                                                <td>{{inboundLoadItem.order.vin_number}}</td>
                                                                                <td>{{inboundLoadItem.order.order_id}}</td>
                                                                                <td>{{(inboundLoadItem.order.brand || {}).title}}</td>
                                                                                <td>{{(inboundLoadItem.order.model || {}).title}}</td>
                                                                                <td>{{inboundLoadItem.price}}</td>
                                                                                <td>{{(inboundLoadItem.currency || {}).label}}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </b-col>
                                                            </b-row>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row><!--/b-row-->
                                </b-col><!--/b-col-->
                                <div class="drawer-footer">
                                    <b-button
                                        size="sm"
                                        type="submit"
                                        variant="primary"
                                        :disabled="global.pendingRequests > 0"
                                        v-b-tooltip.hover :title="$t('button.title.save')"
                                    >
                                        <clip-loader style="display: inline" :loading="true" color="#fff"
                                                     size="12px"
                                                     v-if="global.pendingRequests > 0"></clip-loader>
                                        <i class="fa fa-save mr-1"></i>
                                        {{$t('button.save')}}
                                    </b-button>
                                    <b-button variant="warning" class="ml-3"
                                              size="sm" @click="handleOperationClose()"
                                              v-b-tooltip.hover :title="$t('button.title.cancel')">
                                        <i class="fa fa-arrow-left mr-1"></i> {{$t('button.cancel')}}
                                    </b-button>
                                </div>
                            </b-row><!--/b-row-->
                        </form><!--/form-->
                    </a-drawer>
                </div><!--/.preinvoice-operation-->
                <div class="filter-container">
                    <a-drawer
                        placement="left"
                        :width="'360px'"
                        :wrapStyle="{overflow: 'auto',paddingBottom: '108px'}"
                        :closable="false"
                        @close="filters.visible = !filters.visible"
                        :visible="!operation && filters.visible"
                        :zIndex="10"
                        :title="$t('title.advanceFilters')"
                    >
                        <form @submit.prevent="loadList(listQueryParams, true)" autocomplete="off">
                            <b-row>
                                <b-col sm="12">
                                    <b-form-group
                                        :label="$t('input.supplier')+' *'">
                                        <treeselect
                                            :multiple="true"
                                            :options="dropdowns.suppliers"
                                            placeholder=""
                                            v-model="filters.suppliers"
                                        />
                                    </b-form-group>
                                </b-col><!--/b-col-->
                                <b-col sm="12">
                                    <b-form-group :label="$t('input.fromAddedDate')">
                                        <b-form-datepicker reset-button placeholder="" v-model="filters.from_date"
                                                           class="mb-2"></b-form-datepicker>
                                    </b-form-group>
                                </b-col><!--/b-col-->
                                <b-col sm="12" class="mb-3">
                                    <b-form-group :label="$t('input.toAddedDate')">
                                        <b-form-datepicker reset-button placeholder="" v-model="filters.to_date"
                                                           class="mb-2"></b-form-datepicker>
                                    </b-form-group>
                                </b-col><!--/b-col-->
                            </b-row>
                            <div class="drawer-footer">
                                <b-button size='sm' variant="info" @click="filters.visible = !filters.visible"
                                          class="mr-2" :title="$t('button.title.closePanel')" v-b-tooltip.hover>
                                    {{$t('button.close')}}
                                </b-button>
                                <b-button size='sm' variant="warning" @click="handleResetFilterClick" class="mr-2"
                                          :title="$t('button.title.resetFilter')" v-b-tooltip.hover>
                                    {{$t('button.reset')}}
                                </b-button>
                                <b-button size='sm' variant="primary" button="submit" type="filled"
                                          :title="$t('button.title.filterRecords')" v-b-tooltip.hover>
                                    {{$t('button.apply')}}
                                </b-button>
                            </div><!-- /.drawer-footer -->
                        </form>
                    </a-drawer>
                </div><!-- /.filter-container -->

                <!-- # Excel Export -->
                <b-modal id="excel-export-modal" v-model="exportModal.visibility" hide-footer>
                    <template #modal-title>
                        {{$t('title.exportExcel')}}
                    </template>
                    <div>
                        <form @submit.prevent="handleExcelExportSubmitClick">
                            <div class="mb-5">
                                <b-form-group>
                                    <a href="javascript:;" class="p-3" @click="handleExcelExportSelectAllClick">{{$t('input.checkAll')}}</a>
                                    <a href="javascript:;" class="p-3" @click="handleExcelExportUnSelectAllClick">{{$t('input.unCheckAll')}}</a>
                                </b-form-group>
                                <hr>
                                <table class="table table-sm">
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>{{$t('title.columns')}}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(column, index) in exportModal.columns">
                                        <td>{{index + 1}}</td>
                                        <td>
                                            <b-form-checkbox v-model="column.show" name="check-button"> {{column.label}} </b-form-checkbox>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="drawer-footer">
                                <json-excel
                                        class="btn btn-primary btn-sm"
                                        :fields="exportModal.headers"
                                        worksheet="pre-invoices"
                                        :fetch="handleExcelExportSubmitClick"
                                        name="preInvoices.xls">
                                    <clip-loader style="display: inline" :loading="true" color="#fff"
                                                 size="12px" v-if="global.pendingRequests > 0"></clip-loader>
                                    <i class="fa fa-save mr-1"></i>
                                    {{$t('button.export')}}
                                </json-excel>
                                <b-button variant="warning" class="ml-3"
                                          size="sm" @click="handleExcelExportCancelClick()"
                                          v-b-tooltip.hover :title="$t('button.title.cancel')">
                                    <i class="fa fa-arrow-left mr-1"></i> {{$t('button.cancel')}}
                                </b-button>
                            </div>
                        </form>
                    </div>
                </b-modal><!--/#excel-export-modal-->

            </div><!-- /.card-body-->
        </div><!-- /.card -->
        <div v-if="operation === 'detail'">
            <detail :handle-close-operation="handleOperationClose"></detail>
        </div>
    </div>
</template>
<script>
    import ListingMixin from '../../util/ListingMixin'
    import ExcelExportMixin from './ExcelExportMixin'
    import Error from '../../util/Error'
    import {mapState} from 'vuex'
    import {request} from '../../util/Request'
    import Treeselect from '@riophae/vue-treeselect'
    import Detail from "./detail"
    import JsonExcel from "vue-json-excel"

    const FORM_STATE = {
        _method: 'post',
        id: null,
        deleted_items: [],
        invoice_date: null,
        price: null,
    };

    const FILTER_STATE = {
        visible: false,
        from_date: null,
        to_date: null,
        supplierCarriers: [],
    };

    const COLUMN_DEFINITION = (self) => [
        {
            label: self.$t('column.invoiceNumber'),
            key: 'invoice_number',
            sortable: true,
        },
        {
            label: self.$t('column.supplier'),
            key: 'supplier',
            sortable: false,
        },
        {
            label: self.$t('column.invoiceAmount'),
            key: 'price',
            sortable: true,
        },
        {
            label: self.$t('column.invoiceDate'),
            key: 'invoice_date',
            sortable: true,
        },
        {
            label: self.$t('column.status'),
            key: 'status',
            sortable: true,
        },
        {
            label: self.$t('column.createdAt'),
            key: 'created_at',
            sortable: true,
        },
        (self.$global.hasAnyPermission(['preinvoicesupdate', 'preinvoicesdestroy'])
            ? {
                label: self.$t('column.action'),
                class: 'text-right',
                key: 'action',
                width: 150,
            } : {}),
    ];

    export default {
        mixins: [ListingMixin, ExcelExportMixin],
        components: {
            Treeselect,
            Detail,
            JsonExcel
        },
        data() {
            return {
                operationTitle: 'title.preInvoices',
                formFields: {...FORM_STATE},
                filters: {...FILTER_STATE},
                listUrl: 'pre/invoices',
                columns: COLUMN_DEFINITION(this),
                dropdowns: {
                    supplierCarriers: [],
                },
                show: true,
                editInvoice: [],
                editInvoiceItems: [],
            }
        },
        mounted() {
            this.getSuppliersByType();

            if (this.$route.query && this.$route.query.operation && this.$route.query.oToken) {
                this.handleEditClick(this.$route.query.oToken)
            }

            this.$title = this.$t('topBar.navigations.modules.preInvoices')
        },
        methods: {
            toggleDetails(row) {
                this.$set(row, '_showDetails', ((row._showDetails) ? !row._showDetails : true))
            },
            setOperation(operation = 'add', operationToken = null) {
                this.operationTitle = (operation === 'add' ? 'title.addPrice' : 'title.editPrice')
                this.$router.replace({
                    query: Object.assign({},
                        this.$route.query,
                        {
                            ...this.listQueryParams,
                            operation: operation,
                            oToken: operationToken,
                        },
                    ),
                }).then(() => {
                }).catch(() => {
                })
            },
            async handleSubmit() {
                this.formErrors = new Error({})
                if(this.editInvoiceItems.length === this.formFields.deleted_items.length) {
                    return;
                }

                try {
                    const response = await request({
                        url: 'pre/invoices/update',
                        method: 'post',
                        data: {
                            ...this.formFields,
                        },
                    })

                    if (this.formFields.id) {
                        this.itemUpdated()
                    } else {
                        this.itemAdded()
                    }

                    this.handleOperationClose()
                } catch (error) {
                    if (error.request && error.request.status && error.request.status === 422) {
                        this.formErrors = new Error(JSON.parse(error.request.responseText).errors)
                        return false
                    }

                    this.handleServerError(error)
                }
            },
            async handleDeleteClick(id) {
                try {
                    const response = await request({
                        method: 'post',
                        url: '/pre/invoices/delete',
                        data: {
                            id: id,
                        },
                    })
                    this.loadList(this.listQueryParams)
                    this.itemDeleted()
                } catch (errors) {
                    this.itemDeleteFails()
                }
            },
            async handleEditClick(id) {
                this.editInvoiceItems.length = 0;

                try {
                    const response = await request({
                        method: 'get',
                        url: `/pre/invoices/detail/${id}`,
                    })

                    const {data} = response
                    this.operationTitle = this.$t('title.editInvoice') + ' #' + data.invoice_number;
                    this.editInvoice = data
                    this.editInvoiceItems = data.invoice_items

                    this.formFields = {
                        _method: 'post',
                        id: data.id,
                        invoice_date: data.invoice_date,
                        price: data.price,
                        supplier: data.supplier,
                        deleted_items: []
                    }
                } catch (e) {
                    this.itemEditFails()
                    this.formFields = {...FORM_STATE}
                }
            },
            async getSuppliersByType() {
                try {
                    const slug = 'carrier';
                    const response = await request({
                        url: `/dropdowns/suppliers/${slug}`,
                        method: "post"
                    })

                    const {data} = response
                    this.dropdowns.suppliers = data

                } catch (e) {
                    this.dropdowns.suppliers = []
                }
            },
            handleInvoiceItemClick(item) {
                this.formFields.deleted_items.push(item.object_guid);
                this.formFields.price = (this.formFields.price - item.price);
            },
            handleUndoDeleteInvoiceItemClick(item) {
                const index = _.findIndex(this.formFields.deleted_items, item.object_guid)
                this.formFields.deleted_items.splice(index, 1)
                this.formFields.price = (this.formFields.price + item.price);
            },
            hasListAccess() {
                return this.$global.hasPermission('preinvoicesview')
            },
            getExtraParams() {
                return {
                    filters: {
                        ...this.filters,
                        from_date: ((this.filters.from_date) ? this.$global.dateToUtcDate(this.filters.from_date, 'YYYY-MM-DD', 'YYYY-MM-DD') : ''),
                        to_date: ((this.filters.to_date) ? this.$global.dateToUtcDate(this.filters.to_date, 'YYYY-MM-DD', 'YYYY-MM-DD') : ''),
                    },
                }
            },
            handleResetFilterClick() {
                this.filters = {...FILTER_STATE}
                this.isFilterApplied = 'reset'
                this.handleResetClick()
                this.loadList(this.listQueryParams)
            },
            afterCloseOperation() {
                this.formFields = {...FORM_STATE}
            },
        },
        computed: {
            ...mapState([
                'global',
                'settings'
            ]),
        },
    }
</script>
<style lang="scss">

</style>
